import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ProjectsService } from '../../../../../../../../core/projects.service';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';
import { takeUntil } from 'rxjs/operators';
import { GetVideoIdRequest, UploadFileRequest } from '../../../../../../../../../../shared/core/shared.actions';
import { classifyFile } from '../../../../../../../../../../shared/helpers';
import { FormsService } from '../forms.service';
import { limits } from '../../../../../../../../../../shared/core/shared.selectors';

@Component({
    selector: 'app-question-action-section',
    templateUrl: './question-action-section.component.html',
    styleUrls: ['./question-action-section.component.scss'],
    standalone: false
})
export class QuestionActionSectionComponent implements OnChanges, OnDestroy {
  @ViewChild('fileInput', { static: false }) fileInputRef: any;
  @Input() currentIndex: any = 0;
  @Input() fields: any;
  status: any = 'open';
  enableAddSection = false;

  addMenuOptions = [
    {
      key: 'picture',
      icon: 'camera-outline',
      label: 'Picture',
      handler: () => {
        this.fileInputRef.nativeElement.click();
      },
    },
    {
      key: 'comment',
      icon: 'pencil-outline',
      label: 'Comment',
      handler: () => {
        this.formsService.addComment.next(null);
      },
    },
  ];
  files: any[] = [];
  limits: any;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private formsService: FormsService,
    private store: Store<fromRoot.State>,
    public dialog: MatDialog,
    public route: ActivatedRoute,
    public projectsService: ProjectsService,
    public commonService: CommonService,
    public cdRef: ChangeDetectorRef,
  ) {

    this.store.select(limits)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.limits = data;
      });


  }

  ngOnChanges() {
  }

  onFileSelected(event: any) {
    const files: FileList = event.target.files;  // Get selected files
    const imageFormData = new FormData();
    const videoFiles: File[] = [];

    for (let i = 0; i < files?.length; i++) {
      const file = files?.item(i);

      if (classifyFile(file) === 'video') {
        videoFiles.push(file);
      } else {
        imageFormData.append('inputFiles', file);
      }
    }

    if (imageFormData.has('inputFiles')) {
      const payload = {
        imageFormData,
        parentType: 'popup',
      };
      this.store.dispatch(UploadFileRequest({ payload }));
    }

    if (videoFiles.length > 0) {
      videoFiles.forEach((videoFile: File) => {
        const videoElement = document.createElement('video');
        const reader = new FileReader();

        reader.onloadend = () => {
          videoElement.src = reader.result as string;

          videoElement.onloadedmetadata = () => {
            const videoDuration = videoElement.duration;
            const maxDuration = this.limits.upload.video_size_in_secs;

            if (videoDuration > maxDuration) {
              this.commonService.notification(`Video duration is ${videoDuration} seconds, should be less than ${maxDuration} seconds.`, 'danger');
            } else {
              const payload = {
                videoFile,
                parentType: 'popup',
              };
              this.store.dispatch(GetVideoIdRequest({ payload }));
            }
          };
        };

        reader.readAsDataURL(videoFile);
      });
    }

    this.fileInputRef.nativeElement.value = '';
  }


  next() {
    this.formsService.triggerNext.next(null);
  }

  back() {
    this.formsService.triggerBack.next(null);
  }


  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
